import { MessageCircle } from "lucide-react";
import { useWhatsAppGlobalStatus } from "@/hooks/useWhatsAppGlobalStatus";
import { useUserRole } from "@/hooks/useUserRole";
import { useToast } from "@/components/ui/use-toast";
import { useNavigate } from "react-router-dom";
import { cn } from "@/lib/utils";

export function WhatsAppStatusBadge() {
  const { data, isLoading } = useWhatsAppGlobalStatus();
  const { isManager, isAdmin } = useUserRole();
  const { toast } = useToast();
  const navigate = useNavigate();

  const isConnected = data?.whatsapp_connected === true;

  const handleClick = () => {
    if (isManager || isAdmin) {
      navigate("/dashboard/settings?tab=whatsapp");
    } else {
      toast({
        title: "Acesso Negado",
        description: "A gestão da conexão WhatsApp é feita pelo gestor.",
        variant: "destructive",
      });
    }
  };

  if (isLoading) {
    return <div className="animate-pulse w-9 h-9 rounded-full bg-white/5 mx-2" />;
  }

  return (
    <button
      onClick={handleClick}
      className={cn(
        "relative flex items-center justify-center w-9 h-9 rounded-full transition-all border shrink-0 mx-2",
        isConnected
          ? "bg-[#19F58C]/10 border-[#19F58C]/20 hover:bg-[#19F58C]/25"
          : "bg-red-500/10 border-red-500/20 hover:bg-red-500/25"
      )}
      title={isConnected ? "WhatsApp Conectado" : "WhatsApp Desconectado"}
    >
      <MessageCircle
        className={cn(
          "w-4 h-4",
          isConnected ? "text-[#19F58C]" : "text-red-400"
        )}
      />
      <span
        className={cn(
          "absolute -top-0.5 -right-0.5 w-2.5 h-2.5 rounded-full border-2 border-[#0a0a0a]",
          isConnected ? "bg-[#19F58C] animate-pulse" : "bg-red-500"
        )}
      />
    </button>
  );
}
